const ChatHeader = ({ data }) => {
  return (
    <header className="max-lg:tw-flex-col tw-bg-white tw-px-4 tw-py-1 tw-flex tw-justify-between">
      <div className="tw-flex tw-items-center">
        <div className="tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mr-2">
          <img
            src={data?.messageToImage}
            alt="User Avatar"
            className="tw-w-12 tw-h-12 tw-rounded-full"
          />
        </div>

        <div>
          <h1 className="tw-text-xl !tw-m-0 tw-font-semibold !tw-text-gray-700">
            {data?.messageTo?.split(" ").slice(0, 3).join(" ")}
          </h1>
          <span className="tw-text-gray-400 tw-text-sm">{data?.createdAt}</span>
        </div>
      </div>

      <div className="max-lg:tw-flex max-lg:tw-justify-between max-lg:tw-mt-2">
        <div className="!tw-text-gray-700">
          <span>Status : </span>
          <span className="tw-text-primary tw-capitalize">{data?.status}</span>
        </div>
        <div className="!tw-text-gray-700">
          <span>Type : </span>
          <span className="tw-text-primary">{data?.messageType}</span>
        </div>
      </div>
    </header>
  );
};

export default ChatHeader;
